import { Page } from "../../helbest";
import Image404 from "../../assets/images/base/404.png";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { LangLink } from "../components/LangLink/LangLink";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <>
      <Page
      className="page-404"
      back={true}
      address="/"
      mobileContainer
      noHeader
      headerFix
    >
      <div className="box404">
        <img
          src={Image404}
          className="animated fadeIn delay-1s"
          alt="higaraj"
        />
      </div>
      <p className="delay-1s not-found-text">{t("notfound.Sorry")}</p>
      <div className="w-full flex center-content">
        <LangLink to="/">
          <Button type="primary">{t("common.back_home")}</Button>
        </LangLink>
      </div>
    </Page>
    </>
  );
};

export default NotFound;
